import _ from "lodash";
import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import Reports from "../../common/reports/Reports";
import Autocomplete from "../../framework/Autocomplete";
import Button from "../../framework/Button";
import GlobalContext from "../../framework/GlobalContext";
import Shortcut from "../../framework/Shortcut";
import classes from "./CacUser.module.css";
import CacUserFilter from "./CacUserFilter";
import CacUserSummary from "./CacUserSummary";
import AddCacUser from "./AddCacUser/index";

const CacUser = () => {
  const [showEditCacUser, setShowEditCacUser] = useState(false);
  const [cacUserData, setCacUserData] = useState(null);
  const [onFilterShow, setOnFilterShow] = useState(false);
  const [onColumnShow, setOnColumnShow] = useState(false);
  const [rowLevelCTAs, setRowLevelCTAs] = useState([]);
  const [filterStates, setFilterStates] = useState(null);
  const [refreshData, setRefreshData] = useState(false);
  const [filterParams, setFilterParams] = useState(null);
  const [currentRowData, setCurrentRowData] = useState(null);
  const { setCurrentComponent, currentComponent } = useContext(GlobalContext);
  const reportRef = useRef();
  const editRef = useRef();
  const refreshRef = useRef();
  const addRef = useRef();

  const editCacUser = useCallback((isEdit = false) => {
    if (isEdit) {
      setCacUserData(reportRef.current.getCurrentRowData());
    }
    setShowEditCacUser(true);
  }, []);

  const closeCacUserAc = useCallback(() => {
    setShowEditCacUser(false);
    setCacUserData(null);
    setCurrentComponent("grid_reports");
  }, [setCurrentComponent]);

  const debounceCloseCacUserAc = _.debounce(closeCacUserAc, 200);

  const listener = useCallback(
    (e) => {
      const key = e.key?.toLowerCase();
      const ctrlKey = e.ctrlKey;
      const altKey = e.altKey;
      if (altKey && key === "r") {
        setRefreshData(true);
        return;
      }
      if (altKey && key === "e") {
        return quickExportHandler();
      }
      if (ctrlKey && key === "e") {
        if (currentRowData) return editRef.current.click();
      }
      if (ctrlKey && key === "u") {
        return addRef.current.click();
      }
    },
    [currentRowData]
  );
  const quickExportHandler = () => {
    reportRef?.current?.quickExport({ fileName: "UserReports" });
  };
  const applyFilterHandler = useCallback((params, filterStates) => {
    setRefreshData(false);
    setFilterParams(params);
    setFilterStates(filterStates);
  }, []);

  useEffect(() => {
    const allRowCTAs = [
      <Button
        ref={editRef}
        startIcon={<Shortcut keys={["Ctrl", "E"]} />}
        label="Edit"
        onClick={() => {
          editCacUser(true);
        }}
        isAccessible={currentRowData}
      />,
    ];
    setRowLevelCTAs(allRowCTAs);
  }, [editCacUser, currentRowData]);

  useEffect(() => {
    if (
      !onFilterShow &&
      !showEditCacUser &&
      !onColumnShow &&
      currentComponent === "grid_reports"
    ) {
      document.addEventListener("keyup", listener, false);
    }
    return () => {
      document.removeEventListener("keyup", listener, false);
    };
  }, [currentComponent, listener, onColumnShow, onFilterShow, showEditCacUser]);
  return (
    <div className={classes["cac-report-container"]}>
      <Reports
        identifier="cacUser"
        reportRef={reportRef}
        rowLevelCTAs={rowLevelCTAs}
        filterStates={filterStates}
        filterParams={filterParams}
        onFilterShowClick={setOnFilterShow}
        onColumnShowClick={setOnColumnShow}
        filters={
          <CacUserFilter
            reportRef={reportRef}
            filters={(filters) => {
              setFilterStates(filters);
            }}
            refreshData={refreshData}
            onFilterShow={onFilterShow}
            applyFilters={applyFilterHandler}
          />
        }
        currentRow={(data) => {
          setCurrentRowData(data);
        }}
      />
      <CacUserSummary
        refreshData={() => {
          setRefreshData(true);
        }}
        quickExport={quickExportHandler}
        refreshRef={refreshRef}
        addRef={addRef}
        showAutoComplete={() => {
          editCacUser();
        }}
      />
      <Autocomplete
        show={showEditCacUser}
        height="50%"
        width="50%"
        closeAutoComplete={debounceCloseCacUserAc}
      >
        <AddCacUser
          cacUserData={cacUserData}
          onEscape={debounceCloseCacUserAc}
          onSaveCacUser={() => {
            debounceCloseCacUserAc();
            setRefreshData(true);
          }}
          isEdit={cacUserData}
        />
      </Autocomplete>
    </div>
  );
};

export default CacUser;
